import { StateType } from 'domain/types/base/base';
import { SistemaService } from 'domain/services/sistema/sistemaService'
import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils';

import { SISTEMA_GET, SISTEMAS_GET } from 'domain/types/sistema/sistema';
import { AppThunk } from '../../../utils/reducerUtil';

const _SistemaService = new SistemaService();

export function GetSistema(sistemaID: string): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(SISTEMA_GET, DispatchType.LOADING, "Carregando Sistema", StateType.Master,
            () => dispatch(DispatchLoading(SISTEMA_GET, DispatchType.ERROR, "Erro ao identificar sistema", StateType.Master))))

        const asyncResponse = await _SistemaService.GetSistema(sistemaID)

        if (ResponseValid(asyncResponse, false)) {
            dispatch({
                payload: asyncResponse,
                type: SISTEMA_GET
            })
        }
    }
}

export function GetSistemas(usuarioID: number): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(SISTEMAS_GET, DispatchType.LOADING, undefined, undefined,
            () => dispatch(DispatchLoading(SISTEMAS_GET, DispatchType.ERROR))))

        const asyncResponse = await _SistemaService.GetSistemas(usuarioID)

        if (ResponseValid(asyncResponse, false)) {
            dispatch({
                payload: asyncResponse,
                type: SISTEMAS_GET
            })
        }
    }
}